// ItemContext.js
import React, { createContext, useState, useEffect } from "react";
import { doc, updateDoc, getFirestore } from "firebase/firestore";

export const ItemContext = createContext();

export const ItemProvider = ({ children }) => {
  const [selectedItem, setSelectedItem] = useState(null);
  const [items, setItems] = useState([]); // Assuming you have a list of items
  const db = getFirestore();
  useEffect(() => {
    // Mock items for testing
    setItems([
      { id: 1, title: "Item 1", address: "Address 1" },
      { id: 2, title: "Item 2", address: "Address 2" },
    ]);
  }, []);

  const updateItem = async (userId, addressId, updatedItem) => {
    const addressRef = doc(db, "users", userId, "addresses", addressId);

    // Update the address document in the subcollection
    await updateDoc(addressRef, updatedItem);

    // Update the local state
    setItems(
      items.map((item) =>
        item.id === addressId ? { ...item, ...updatedItem } : item
      )
    );
  };

  return (
    <ItemContext.Provider value={{ selectedItem, setSelectedItem, updateItem }}>
      {children}
    </ItemContext.Provider>
  );
};
